<template>
  <div>
    <b-modal id="modal-delete-hirarki" size="md" centered title="Perhatian .... !!!" header-bg-variant="danger" header-text-variant="light">
      <p>Apakah anda yakin akan menghapus data ini ?</p>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-delete-hirarki')"> Tidak </b-button>
        <b-button variant="primary" @click="hapus()"> Ya </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "modalDelete",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Hapus",
    };
  },
  methods: {
    hapus() {
      let vm = this;
      vm.$axios
        .post("levelAgreement/delete", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGHAPUS DATA MASTER POSISI",
              showing: true,
            });
            this.$bvModal.hide("modal-delete-hirarki");
          } else {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err;
          vm.button = "Hapus";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
